import classNames from "classnames";
import saveAs from "file-saver";
import type { MouseEvent } from "react";
import { useCallback } from "react";
import api from "../../api";
import { useToast } from "../../mantine/notifications/useToast";
import "./DownloadLink.scss";

export interface DownloadLinkProps {
  url: string;
  filename: string;
  children?: React.ReactNode;
  className?: string;
}

function DownloadLink({
  url,
  filename,
  children,
  className
}: DownloadLinkProps) {
  const { showErrorToast } = useToast();

  const onDownloadClick = useCallback(
    async (e: MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      try {
        const response = await api.get(url, {
          responseType: "blob",
          transformResponse: []
        });

        const blob = new Blob([response.data]);

        saveAs(blob, filename);
      } catch (e) {
        showErrorToast(e);
      }
    },
    [filename, url, showErrorToast]
  );

  return (
    <span
      className={classNames("download-link", className)}
      onClick={onDownloadClick}
    >
      {children}
    </span>
  );
}

export { DownloadLink };
